module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-005.8316fbb9.jpg";